import axios from "axios";
import mapAPIKey from "config/googleMapsAPIKey";

interface LocationResponse {
  city: string;
  state: string;
  country: string;
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GeocodeResult {
  address_components: AddressComponent[];
}

interface GeocodeResponse {
  results: GeocodeResult[];
}

export async function getLocation(
  lat: number,
  lng: number,
): Promise<LocationResponse> {
  const response = await axios.get<GeocodeResponse>(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=${mapAPIKey}`,
  );
  const addressComponents = response.data.results[0].address_components;
  //   let last = addressComponents.length - 1;
  //   let city = addressComponents[last - 4].long_name;
  //   let state = addressComponents[last - 2].long_name;
  //   let country = addressComponents[last - 1].long_name;
  let city: string = "";
  let state: string = "";
  let country: string = "";
  addressComponents.forEach((comp) => {
    const { types } = comp;
    if (types.includes("country")) {
      country = comp.long_name;
    } else if (types.includes("administrative_area_level_1")) {
      state = comp.long_name;
    } else if (types.includes("locality") || types.includes("sublocality")) {
      city = comp.long_name;
    }
  });

  return { city, state, country };
}
